import { createFileRoute } from '@tanstack/react-router'

import { preloadListSalesChannelTypes } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/sales-channels/types')({
	loader: async ({ context }) => await preloadListSalesChannelTypes(context, {}),
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.SalesChannelTypes.Title()
	}
})
